import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { JobOffer, JobOfferModuleColumn } from 'job/job-offer';

export interface JobOfferModuleColumnDocument {
	readonly moduleColumnId: string;
	readonly organizationModuleId: string;
}

export interface JobOfferDocument {
	readonly id: string;
	readonly title: string;
	readonly ownerId: string;
	readonly keyPoints: string;
	readonly companyName: string;
	readonly documentUrl: string;
	readonly contractType: string;
	readonly modulesColumn: JobOfferModuleColumnDocument[];
}

export type JobOfferState = EntityState<JobOfferDocument, string>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'jobOffers' })
export class JobOfferStore extends EntityStore<JobOfferState> {
	constructor() {
		super();
	}

	public asEntity(document: JobOfferDocument): JobOffer {
		return document
			? new JobOffer(
					document.id,
					document.title,
					document.ownerId,
					document.keyPoints,
					document.companyName,
					document.documentUrl,
					document.contractType,
					(document.modulesColumn || []).map((column) => ({
						moduleColumnId: column.moduleColumnId,
						organizationModuleId: column.organizationModuleId,
					}))
			  )
			: null;
	}

	public asDocument(jobOffer: JobOffer): JobOfferDocument {
		return jobOffer
			? {
					id: jobOffer.id,
					ownerId: jobOffer.ownerId,
					modulesColumn: (jobOffer.modulesColumn || []).map((column) =>
						this._asJobOfferModuleColumnDocument(column)
					),
					documentUrl: jobOffer.documentUrl,
					title: jobOffer.title,
					companyName: jobOffer.companyName,
					contractType: jobOffer.contractType,
					keyPoints: jobOffer.keyPoints,
			  }
			: null;
	}

	private _asJobOfferModuleColumnDocument(
		jobOfferModuleColumn: JobOfferModuleColumn
	): JobOfferModuleColumnDocument {
		return jobOfferModuleColumn
			? {
					moduleColumnId: jobOfferModuleColumn.moduleColumnId,
					organizationModuleId: jobOfferModuleColumn.organizationModuleId,
			  }
			: null;
	}
}
